import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DialogBox from '../../DialogBox'

function formatTimer(number: number): string {
  if (number <= 0) return '00'
  return number < 10 ? `0${number}` : `${number}`
}

interface SessionTimeoutModalActionProps {
  onLogout: () => void
  onContinue: () => void
}

function SessionTimeoutModalAction(
  {
    onLogout,
    onContinue
  }: SessionTimeoutModalActionProps
): JSX.Element {
  return (
    <>
      <Button
        variant="text"
        data-testid="choose-version-dialog-action-cancel"
        onClick={onLogout}
      >
        Logout
      </Button>
      <Button
        variant="contained"
        onClick={onContinue}
      >
        Continue
      </Button>
    </>
  )
}

export interface SessionTimeoutModalProps {
  open: boolean
  onLogout: () => void
  onContinue: () => void
}

export function SessionTimeoutModal({
  open,
  onLogout,
  onContinue
}: SessionTimeoutModalProps): JSX.Element {
  const [counterSeconds, setCounterSeconds] = useState<number>(180)
  useEffect(() => {
    if (counterSeconds <= 0) {
      onLogout()
      return () => { /* */ }
    }
    // Note: Need to use setTimeout instead of setInterval to short-circuit the counter
    const timer = setTimeout(() => {
      setCounterSeconds(counterSeconds - 1)
    }, 1000)

    return () => {
      clearTimeout(timer)
    }
  }, [counterSeconds])

  const minutes = Math.floor(counterSeconds / 60)
  const seconds = counterSeconds % 60
  const countdown = `${formatTimer(minutes)}:${formatTimer(seconds)}`
  return (
    <DialogBox
      open={open}
      title={`You will be logged out in ${countdown} due to inactivity`}
      description="Click Logout to logout immediately or Continue to return to your session."
      actions={(
        <SessionTimeoutModalAction onContinue={onContinue} onLogout={onLogout} />
      )}
    />
  )
}
